import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const fetchBusinessUnits = async periodName => await fetch(
  Config.endpoints.FETCH_BUSINESS_UNITS
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching Business Units failed' }))
  .then(parseAsJson);

export const fetchEnabledFlagValues = async () => await fetch(
  Config.endpoints.FETCH_ENABLED_FLAG_VALUES
)
  .then(handleErrors({ errorMessage: 'Fetching line of business values failed' }))
  .then(parseAsJson);

export const fetchBusinessCodes = async () => await fetch(
  Config.endpoints.FETCH_BUSINESS_CODES
)
  .then(handleErrors({ errorMessage: 'Fetching business codes failed' }))
  .then(parseAsJson);

export const addBusinessUnit = async ({ businessUnitData, periodName }) => await fetch(
  Config.endpoints.ADD_BUSINESS_UNIT
    .replace(/:periodName/, periodName),
  {
    method: 'POST',
    body: JSON.stringify(businessUnitData),
  }
)
  .then(handleErrors({ errorMessage: 'Adding Business Unit failed' }));

export const updateBusinessUnit = async ({ businessUnitData, periodName }) => await fetch(
  Config.endpoints.UPDATE_BUSINESS_UNIT
    .replace(/:businessUnit/, businessUnitData.businessUnit)
    .replace(/:periodName/, periodName),
  {
    method: 'PUT',
    body: JSON.stringify(businessUnitData),
  }
)
  .then(handleErrors({ errorMessage: 'Updating Business Unit failed' }));

export const deleteBusinessUnit = async ({ periodName, businessUnit }) => await fetch(
  Config.endpoints.DELETE_BUSINESS_UNIT
    .replace(':businessUnit', businessUnit)
    .replace(':periodName', periodName), {
    method: 'DELETE',
  }
)
  .then(handleErrors({ errorMessage: 'Removing Business Unit failed' }));

export const addBusinessCode = async ({ businessData }) => await fetch(
  Config.endpoints.ADD_BUSINESS_CODE,
  {
    method: 'POST',
    body: JSON.stringify(businessData),
  }
)
  .then(handleErrors({ errorMessage: 'Adding Business failed' }));
